/* Anemoia — one plain-language line at the top of each nav dropdown.

   The menu names are the brand's own ("The Vestiaire", "The House", "The Details") and they stay
   exactly as they are. The problem they create for a first-time visitor is that none of them says
   what's behind it — nothing in the header reads as "products". So each dropdown gets a single
   quiet eyebrow naming its contents in ordinary words. Nothing is renamed, moved, or removed.

   Labels describe the REAL menu contents (verified against the live main-menu / header-right):
     The Vestiaire  → 8 garment categories (Overcoats … Dresses)
     The House      → Paintings, The Curio
     The Details    → Jewelry, Accessories
     Material Notes → the 7 material stories + Overview
   "The Good Old" and "Worn & Loved" have no dropdown, so there is nowhere to put a line — left alone.

   Purely additive and idempotent: injects one <li> per submenu, skips if already present, and
   no-ops on any menu name it doesn't recognise. Delete this file's script tag to revert. */
(function () {
  'use strict';

  var LABELS = {
    'the vestiaire': 'Shop by category',
    'the house': 'Paintings & curios',
    'the details': 'Jewellery & accessories',
    'material notes': 'Guides by material'
  };

  function css() {
    if (document.getElementById('anav-css')) return;
    var s = document.createElement('style');
    s.id = 'anav-css';
    s.textContent = [
      '.anav-eyebrow{',
      'display:block;list-style:none;pointer-events:none;',
      'font-family:var(--font-body-family);font-size:10px;font-weight:500;',
      'letter-spacing:.18em;text-transform:uppercase;color:#8c6e4a;',
      'padding:14px 2rem 6px;margin:0;',
      '}',
      '@media (max-width:989px){.anav-eyebrow{padding:12px 3rem 6px;}}'
    ].join('');
    document.head.appendChild(s);
  }

  function run() {
    var subs = document.querySelectorAll('.header__submenu');
    Array.prototype.forEach.call(subs, function (sub) {
      if (sub.querySelector(':scope > .anav-eyebrow')) return;          // already labelled
      var host = (sub.closest && sub.closest('details')) || sub.parentElement;
      var trigger = host && host.querySelector('.header__menu-item');
      if (!trigger) return;
      var key = (trigger.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      var label = LABELS[key];
      if (!label) return;                                               // unknown menu → leave it
      css();
      var li = document.createElement('li');
      li.className = 'anav-eyebrow';
      li.setAttribute('aria-hidden', 'true');                           // decorative; the links carry the meaning
      li.textContent = label;
      sub.insertBefore(li, sub.firstChild);
    });
  }

  function boot() {
    run();
    // The header re-renders on section reload (theme editor) and the mobile drawer builds late.
    document.addEventListener('shopify:section:load', run);
    var n = 0, iv = setInterval(function () { run(); if (++n > 10) clearInterval(iv); }, 400);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

/* Anemoia — submenu-group accordion.

   The "Designers" dropdown holds four collapsible groups (Mills & fibre houses, Tailoring houses,
   Fashion houses, Quiet labels). Native <details> stay open independently, so opening several turns
   the menu into a tall wall of links. This makes the groups mutually exclusive: opening one closes
   its siblings — on both the desktop dropdown and the mobile drawer. Idempotent and reversible. */
(function () {
  'use strict';

  function isGroup(d) {
    var id = d.id || '';
    if (id.indexOf('Details-HeaderSubMenu-') === 0) return true;               // desktop dropdown group
    if (id.indexOf('Details-menu-drawer-') === 0                               // mobile drawer group
        && id !== 'Details-menu-drawer-container'
        && id.indexOf('Details-menu-drawer-menu-item-') !== 0) return true;
    return false;
  }

  function closeSiblings(d) {
    var li = d.parentElement; if (!li) return;
    var ul = li.parentElement; if (!ul) return;
    Array.prototype.forEach.call(ul.children, function (child) {
      if (child === li || !child.querySelector) return;
      var od = child.querySelector(':scope > details');
      if (od && od.open && isGroup(od)) od.open = false;
    });
  }

  function bind() {
    var all = document.querySelectorAll('details');
    Array.prototype.forEach.call(all, function (d) {
      if (d.__anavAcc || !isGroup(d)) return;
      d.__anavAcc = true;
      d.addEventListener('toggle', function () { if (d.open) closeSiblings(d); });
    });
  }

  function boot() {
    bind();
    document.addEventListener('shopify:section:load', bind);
    var n = 0, iv = setInterval(function () { bind(); if (++n > 10) clearInterval(iv); }, 400);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

/* Anemoia — close header dropdowns on an outside click.

   Dawn's <header-menu> only closes a dropdown on keyboard focusout (Tab away) or re-clicking its
   own trigger. A plain mouse click elsewhere on the page (the hero image, empty space, another
   dropdown's trigger) doesn't move focus in every browser, so the menu can stay open until the
   visitor clicks the trigger a second time. This adds the missing "click outside closes it" rule
   for every open <header-menu> details element, without touching Dawn's own file. */
(function () {
  'use strict';

  function closeOpenMenus(exceptEl) {
    var openMenus = document.querySelectorAll('header-menu details[open]');
    Array.prototype.forEach.call(openMenus, function (details) {
      var host = details.closest('header-menu');
      if (exceptEl && host && host.contains(exceptEl)) return;   // the click that opened/toggled this one
      details.removeAttribute('open');
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    closeOpenMenus(e.target);
  });

  // A tap on mobile fires click too, but keep this defensive for touch-only browsers.
  document.addEventListener('touchstart', function (e) {
    closeOpenMenus(e.target);
  }, { passive: true });
})();
